import { createComponent } from '@carvana/merch-components';

export const Container = createComponent('div', {
  className:
    'flex w-full flex-col items-center gap-2xl rounded-[6px] border border-grey-2 bg-white p-2xl text-blue-6  md:gap-4xl md:p-3xl'
});

export const Wrapper = createComponent('div', {
  className:
    'flex w-full flex-col divide-y divide-grey-2 m:flex-row m:justify-center m:divide-x  m:divide-y-0'
});
